module.exports = __webpack_public_path__ + "img/sdk-entry-back.1f22d738.png";